<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-container
        v-if="!loading && item.title"
        class="py-10 py-md-13 py-lg-16 px-md-12 px-lg-3 my-md-14 item"
        :fluid="mdAndDown"
      >
        <v-row align="center" justify="center">
          <v-col cols="12" :md="image ? 6 : 8" :lg="image ? 5 : 7">
            <TitleWidget class="text-center" :class="{ 'text-md-left': image }">
              {{ item.title }}
            </TitleWidget>

            <img
              v-if="image && smAndDown"
              class="d-block mt-12 item-img"
              :src="files + image + '?resize=1&w=960'"
              :alt="item.title"
              width="100%"
            />

            <div
              class="
                grey--text
                text--darken-1 text-center
                mt-8 mt-md-12
                ck-content
                item-text
              "
              :class="{ 'text-md-left': image }"
              v-html="item.introduction"
            ></div>

            <ButtonWidget
              class="text-center mt-6"
              :class="{ 'text-md-left': image }"
              :to="path"
            >
              SAIBA MAIS
            </ButtonWidget>
          </v-col>

          <v-col v-if="image && !smAndDown" cols="12" md="6" lg="7">
            <img
              class="d-block pl-lg-10 item-img"
              :src="files + image + '?resize=1&w=960'"
              :alt="item.title"
              width="100%"
            />
          </v-col>
        </v-row>
      </v-container>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _config = {
  mod: "about",
  path: "/sobre",
};

export default {
  data: () => ({
    loading: true,
    path: _config.path,
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    image() {
      return this.item.img &&
        this.item.img.featured &&
        this.item.img.featured.path
        ? this.item.img.featured.path
        : "";
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-text {
    line-height: 1.8;
  }

  &-img {
    aspect-ratio: 585 / 410;
    -o-object-fit: cover;
    object-fit: cover;
  }
}
</style>
